/*
 * Cart "You might also like" dynamic loader.
 *
 * Priority:
 *   1. Recently viewed products (shopify_recently_viewed cookie)
 *   2. Related recommendations for the first cart line item
 *
 * Refreshes when the cart changes so nothing already in cart is offered.
 */
(function () {
  'use strict';

  var COOKIE = 'shopify_recently_viewed';
  var CARD_SECTION = 'api-cart-ymal-card';
  var LIST_SECTION = 'api-cart-ymal-list';

  function readRecentlyViewed() {
    var parts = document.cookie.split('; ');
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].indexOf(COOKIE + '=') === 0) {
        var raw = decodeURIComponent(parts[i].split('=')[1] || '');
        if (!raw) return [];
        return raw.split(' ').filter(Boolean);
      }
    }
    return [];
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function fetchCardByHandle(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '?section_id=' + CARD_SECTION, {
      credentials: 'same-origin',
    })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return null;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        return tmp.querySelector('[data-ymal-card]');
      })
      .catch(function () { return null; });
  }

  function fetchRecommendations(productId, limit) {
    var base = (window.theme && window.theme.routes && window.theme.routes.product_recommendations_url) || '/recommendations/products';
    var url = base + '?section_id=' + LIST_SECTION + '&product_id=' + productId + '&intent=related&limit=' + limit;
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return [];
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        return Array.prototype.slice.call(tmp.querySelectorAll('[data-ymal-card]'));
      })
      .catch(function () { return []; });
  }

  function updateArrows(root) {
    var track = root.querySelector('[data-cart-ymal-track]');
    var prev = root.querySelector('[data-cart-ymal-prev]');
    var next = root.querySelector('[data-cart-ymal-next]');
    if (!track) return;
    var hasOverflow = track.scrollWidth > track.clientWidth + 2;
    root.classList.toggle('cart-ymal--overflow', hasOverflow);
    if (prev) prev.toggleAttribute('disabled', track.scrollLeft <= 2);
    if (next) next.toggleAttribute('disabled', track.scrollLeft >= (track.scrollWidth - track.clientWidth - 2));
  }

  function stepDistance(track) {
    var card = track.querySelector('.ymal-card');
    if (!card) return track.clientWidth * 0.8;
    var style = window.getComputedStyle(track);
    var gap = parseFloat(style.columnGap || style.gap || 0) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function bindNav(root) {
    if (root.dataset.ymalNavBound === '1') return;
    root.dataset.ymalNavBound = '1';
    var track = root.querySelector('[data-cart-ymal-track]');
    var prev = root.querySelector('[data-cart-ymal-prev]');
    var next = root.querySelector('[data-cart-ymal-next]');
    if (!track || !prev || !next) return;
    prev.addEventListener('click', function () {
      track.scrollBy({ left: -stepDistance(track), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: stepDistance(track), behavior: 'smooth' });
    });
    track.addEventListener('scroll', function () { updateArrows(root); }, { passive: true });
    window.addEventListener('resize', function () { updateArrows(root); });

  }

  function render(root, cards) {
    var track = root.querySelector('[data-cart-ymal-track]');
    if (!track) return;
    track.innerHTML = '';
    if (!cards.length) {
      root.hidden = true;
      return;
    }
    root.hidden = false;
    cards.forEach(function (card) { track.appendChild(card); });
    track.scrollLeft = 0;
    requestAnimationFrame(function () { updateArrows(root); });
  }

  function dedupe(cards) {
    var seen = {};
    return cards.filter(function (card) {
      var id = card.getAttribute('data-product-id');
      if (!id || seen[id]) return false;
      seen[id] = true;
      return true;
    });
  }

  function load(root) {
    var limit = parseInt(root.getAttribute('data-limit') || '8', 10);
    if (!limit || limit < 1) limit = 8;

    fetchCart().then(function (cart) {
      var cartIds = {};
      var firstCartProductId = null;
      if (cart && cart.items && cart.items.length) {
        firstCartProductId = cart.items[0].product_id;
        cart.items.forEach(function (item) {
          cartIds[String(item.product_id)] = true;
        });
      }

      var handles = readRecentlyViewed();

      var cartCount = cart && cart.item_count ? cart.item_count : 0;
      var handleFetchCount = Math.min(handles.length, limit + cartCount + 3);
      var recentPromise;
      if (handleFetchCount > 0) {
        recentPromise = Promise.all(handles.slice(0, handleFetchCount).map(fetchCardByHandle))
          .then(function (nodes) {
            return nodes.filter(function (n) { return n && !cartIds[n.getAttribute('data-product-id')]; });
          });
      } else {
        recentPromise = Promise.resolve([]);
      }

      recentPromise.then(function (recentCards) {
        recentCards = dedupe(recentCards).slice(0, limit);

        if (recentCards.length >= limit || !firstCartProductId) {
          render(root, recentCards.slice(0, limit));
          return;
        }

        var need = limit - recentCards.length + Object.keys(cartIds).length;
        fetchRecommendations(firstCartProductId, need + 4).then(function (recCards) {
          var extra = recCards.filter(function (c) { return !cartIds[c.getAttribute('data-product-id')]; });
          var combined = dedupe(recentCards.concat(extra)).slice(0, limit);
          render(root, combined);
        });
      });
    });
  }

  function init(root) {
    if (root.dataset.ymalInit === '1') return;
    root.dataset.ymalInit = '1';
    bindNav(root);
    load(root);
  }

  function refreshAll() {
    document.querySelectorAll('[data-cart-ymal]').forEach(function (root) {
      load(root);
    });
  }

  function scan() {
    document.querySelectorAll('[data-cart-ymal]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('theme:cart:change', refreshAll);
  document.addEventListener('shopify:section:load', scan);

  /* --------------------------------------------------------------------------
     "Back to cart" injection on the quick-add modal when opened from a YMAL card.
     -------------------------------------------------------------------------- */

  var ymalOpenedQuickAdd = false;

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('.ymal-card [data-quick-add-btn], .ymal-card [data-add-to-cart]');
    if (btn) ymalOpenedQuickAdd = true;
  }, true);

  function injectBackButton(modal) {
    if (!modal || modal.dataset.ymalBackInjected === '1') return;
    modal.dataset.ymalBackInjected = '1';

    var closeOuter = modal.querySelector('.product-quick-add__close-outer') || modal.querySelector('[data-quick-add-modal-close]');
    if (!closeOuter) return;

    var back = document.createElement('button');
    back.type = 'button';
    back.className = 'product-quick-add__back cart-ymal-back-btn';
    back.setAttribute('aria-label', 'Back to cart');
    back.innerHTML =
      '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">' +
      '<path d="M15 6L9 12l6 6" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';

    back.addEventListener('click', function () {
      var closeBtn = modal.querySelector('[data-quick-add-modal-close]');
      if (closeBtn) closeBtn.click();
      setTimeout(function () {
        document.dispatchEvent(new CustomEvent('theme:cart:toggle', { bubbles: true }));
      }, 60);
    });

    if (closeOuter.parentNode) {
      closeOuter.parentNode.insertBefore(back, closeOuter);
    }
  }

  var modalObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes && m.addedNodes.forEach(function (node) {
        if (!(node instanceof HTMLElement)) return;
        var modal = node.matches && node.matches('[data-quick-add-modal]')
          ? node
          : (node.querySelector && node.querySelector('[data-quick-add-modal]'));
        if (modal && ymalOpenedQuickAdd) {
          injectBackButton(modal);
          ymalOpenedQuickAdd = false;
        }
      });
    });
  });
  modalObserver.observe(document.body, { childList: true, subtree: true });
})();
